import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.split.js";
import jwtDecode from 'jwt-decode';
import LOGS from '~/const/errorsLog';
import USE_MERCURE from '~/const/mercure';
import { calculateDifferenceInMinutes } from '~/helpers/refresh-auth-helper';
import { refreshToken, updateUserToken } from '~/services/user';
var parseHash = hash => hash.split('&').reduce((acc, item) => {
  var currentAcc = acc;
  var parts = item.split('=');
  [, currentAcc[parts[0]]] = parts;
  return currentAcc;
}, {});
var isTokenAudienceSTS = decodedToken => {
  var {
    aud
  } = decodedToken;
  return Array.isArray(aud) && aud.includes('sts');
};
var shouldRefreshToken = locale => {
  return window.localStorage.getItem('MDM_ACCESS_TOKEN') && USE_MERCURE(locale.iso);
};
var getTokenState = () => {
  var decodedToken = jwtDecode(window.localStorage.getItem('MDM_ACCESS_TOKEN'));
  var tokenExpiresAt = Number(decodedToken.exp * 1000);
  var currentTimestamp = new Date().getTime();
  var differenceInMinute = calculateDifferenceInMinutes(tokenExpiresAt, currentTimestamp);
  var minutesBeforeExpiry = Math.sign(differenceInMinute) === 1 ? differenceInMinute : 0;
  var minutesExpiryThreshold = 5;
  return {
    forceRefresh: Boolean(window.localStorage.getItem('forceRefreshToken')),
    alreadyExpired: minutesBeforeExpiry === 0,
    almostExpired: minutesBeforeExpiry <= minutesExpiryThreshold,
    isAudienceSTS: isTokenAudienceSTS(decodedToken)
  };
};
var doRefreshToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (app, alreadyExpired, forceRefresh, isAudienceSTS) {
    try {
      var token;
      if (isAudienceSTS) {
        var _data$refreshToken$to, _data$refreshToken;
        var data = yield refreshToken({
          app
        });
        token = (_data$refreshToken$to = data === null || data === void 0 ? void 0 : (_data$refreshToken = data.refreshToken) === null || _data$refreshToken === void 0 ? void 0 : _data$refreshToken.token) !== null && _data$refreshToken$to !== void 0 ? _data$refreshToken$to : null;
      } else {
        var _data$updateUserToken, _data$updateUserToken2;
        var _data = yield updateUserToken({
          app
        });
        token = (_data$updateUserToken = _data === null || _data === void 0 ? void 0 : (_data$updateUserToken2 = _data.updateUserToken) === null || _data$updateUserToken2 === void 0 ? void 0 : _data$updateUserToken2.token) !== null && _data$updateUserToken !== void 0 ? _data$updateUserToken : null;
      }
      if (!token) throw new Error("MDM_REFRESH_TOKEN_EMPTY STS");
      if (forceRefresh) window.localStorage.removeItem('forceRefreshToken');
      window.localStorage.setItem('MDM_ACCESS_TOKEN', token);
    } catch (error) {
      app.$logger.customFilter(error, "".concat(LOGS.MDM_REFRESH_TOKEN, " ").concat(isAudienceSTS ? 'STS' : 'MERCURE'));
      if (alreadyExpired) {
        window.localStorage.removeItem('MDM_ACCESS_TOKEN');
      }
    }
  });
  return function doRefreshToken(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export var refreshTokenIfNecessary = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (_ref2) {
    var {
      app,
      store
    } = _ref2;
    if (!shouldRefreshToken(store.getters['i18n/locale'])) return;
    var {
      alreadyExpired,
      almostExpired,
      isAudienceSTS,
      forceRefresh
    } = getTokenState();
    if (!forceRefresh && !alreadyExpired && !almostExpired) return;
    yield doRefreshToken(app, alreadyExpired, forceRefresh, isAudienceSTS);
  });
  return function refreshTokenIfNecessary(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
export default parseHash;